import { Component, OnInit } from '@angular/core';
declare let $: any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  constructor() {}

  /**
   * Opens the Startup TN website in a new tab.
   */
  Startupweb() {
    // Open the Startup TN website in a new tab
    window.open('https://startuptn.in/', '_blank');
  }

  /**
   * Scrolls to the Connect With Incubator section when the button is clicked.
   */
  connectIncubator() {
    // Scroll to the Connect With Incubator section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 2500);
  }
  /**
   * On init, sets up the scroll event listener
   */
  ngOnInit(): void {
    $(document).ready(() => {
      // Listen for the window scroll event
      $(window).on('scroll', () => {
        // If the scroll position is greater than 100px, show the back to top button
        if ($(this).scrollTop() > 100) {
          $('#back-to-top').fadeIn();
        } else {
          // Otherwise, hide the button
          $('#back-to-top').fadeOut();
        }
      });
      // Add an event listener to the back to top button
      $('#back-to-top').click(() => {
        // On click, animate the scroll to the top of the page
        $('html, body').animate(
          {
            scrollTop: 0,
          },
          600 // animation speed
        );
        // Return false to prevent the default link behavior
        return false;
      });
    });
  }
  /**
   * Opens the Twitter page in a new window
   */
  twiterclick() {
    // Open the Twitter page in a new window
    window.open('https://x.com/TheStartupTN?s=20', '_blank');
  }
  /**
   * Opens the LinkedIn page in a new window
   */
  Linkedinclick() {
    window.open('https://www.linkedin.com/company/thestartuptn/', '_blank');
  }
  /**
   * Opens the Instagram page in a new window
   */
  instaclick() {
    window.open('https://www.instagram.com/thestartuptn/?hl=en', '_blank');
  }
  /**
   * Opens the Facebook page in a new window
   */
  facebookclick() {
    window.open('https://www.facebook.com/TheStartupTN/', '_blank');
  }
}
